import { render } from "./VucutKitleIndeksi.vue?vue&type=template&id=f599ff4c"
import script from "./VucutKitleIndeksi.vue?vue&type=script&lang=js"
export * from "./VucutKitleIndeksi.vue?vue&type=script&lang=js"

import "./VucutKitleIndeksi.vue?vue&type=style&index=0&id=f599ff4c&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__